import "./ElectricalServices.module.css";
import Header from "@/reusable_sections/Header";
import HeroElectrical from "./sections/HeroElectrical";
import Credentials from "./sections/Credentials";
import ServiceCategoriesPricing from "./sections/ServiceCategoriesPricing";
import Electrical from "./sections/Electrical";
import MasterElectricians from "./sections/MasterElectricians";
import ElectricalServiceTestimonials from "./sections/ElectricalServiceTestimonials";
import ElectricalSafetyFAQ from "./sections/ElectricalSafetyFAQ";
import ReadyToSchedule from "./sections/ReadyToSchedule";
import Booking from "./sections/Booking";
import Footer from "@/reusable_sections/Footer";
export default function ElectricalServicesPage() {
  return <div>
      <Header />
      <HeroElectrical />
      <Credentials />
      <ServiceCategoriesPricing />
      <Electrical />
      <MasterElectricians />
      <ElectricalServiceTestimonials />
      <ElectricalSafetyFAQ />
      <ReadyToSchedule />
      <Booking />
      <Footer />
    </div>;
}